export default __webpack_public_path__ + "ed03511.png";